export function commonFunc() {
  console.log('共通JS');
}